import Vue, { VueConstructor } from 'vue';
import VueRouter from 'vue-router';
import { CoreOptions } from '../../../../src';
import IModule from '../../../module';
import loadModuleApi from './services/v1';

import translations from './localization/translations.json';

import widgetEventListCard from './views/pages/widget-event-list-card.vue';
import widgetEventList from './views/pages/widget-event-list.vue';
import widgetEventRegister from './views/pages/widget-event-register.vue';
import widgetEventSearch from './views/pages/widget-event-search.vue';
import widgetEventDetail from './views/pages/widget-event-detail.vue';
import widgetEventCard from './components/widget-event-card.vue';

declare module '../../../../src/plugins/config/config' {
  interface ConfigType {
    'widget-toccofilter'?: string,
    'widget-eventid'?: string,
    'widget-pagesize'?: number,
    'widget-toccoeventkey'?: string,
    'widget-tocco-text-event-search-no-entries': string,
    [textNoEntries: `widget-tocco-text-event-search-no-entries-${string}`]: string | undefined;
    'widget-tocco-redirect-agb': string,
    [redirectAGB: `widget-tocco-redirect-agb-${string}`]: string | undefined;
    'widget-tocco-redirect-privacy': string,
    [redirectPrivacy: `widget-tocco-redirect-privacy-${string}`]: string | undefined;
    'widget-tocco-redirect-event-search': string,
    [redirectEvents: `widget-tocco-redirect-event-search-${string}`]: string | undefined;
    'widget-tocco-redirect-event-detail': string,
    [redirectEventDetail: `widget-tocco-redirect-event-detail-${string}`]: string | undefined;
    'widget-tocco-redirect-event-register': string,
    [redirectEventRegister: `widget-tocco-redirect-event-register-${string}`]: string | undefined;
  }

}

export default {
  async loadModule(options: CoreOptions, vue: VueConstructor) {
    vue.use(loadModuleApi);
    vue.component('WidgetEventListCard', widgetEventListCard);
    vue.component('WidgetEventList', widgetEventList);
    vue.component('WidgetEventRegister', widgetEventRegister);
    vue.component('WidgetEventSearch', widgetEventSearch);
    vue.component('WidgetEventDetail', widgetEventDetail);
    vue.component('WidgetEventCard', widgetEventCard);
    await vue.$guards.waitForAppLoad();
    const router = (options.router instanceof VueRouter) ? options.router : vue.$router;
    router.addRoute({ name: '', path: '/_widget/events', component: widgetEventSearch });
    router.addRoute({ name: '', path: '/_widget/events/next-cards', component: widgetEventListCard });
    router.addRoute({ name: '', path: '/_widget/events/next-list', component: widgetEventList });
    router.addRoute({
      name: '', path: '/_widget/events/register', alias: '/_widget/events/:eventid/register', component: widgetEventRegister,
    });
    router.addRoute({
      name: '', path: '/_widget/events/detail', alias: '/_widget/events/:eventid', component: widgetEventDetail,
    });
    Vue.$translation.addTranslations(translations);
  },
  async unloadModule(options: CoreOptions, vue: VueConstructor) {
    // Router does not seem to have a removeRoute in this version
    // Unclear how to unload components as well

    Vue.$translation.removeTranslations(translations);
    throw new Error('Not implemented');
  },
} as IModule;
